<template>
  <div class="edit-category-icon">
    <!-- Modalı Açan Düymə -->
    <a-icon type="edit" v-if="user && user.structure && user.structure.name === 'AMIS'" style="margin-left: 40px; cursor: pointer" @click="openModal" />

    <!-- Modal Komponenti -->
    <a-modal
      :visible="isModalOpen"
      title="Təsnifatların Redaktəsi"
      width="1200px"
      :footer="null"
      :destroyOnClose="true"
      @cancel="handleClose"
    >
      <div style="padding-top: 16px;">
        <a-row :gutter="16">
          <!-- 1. Şikayət Təsnifatları Card-ı -->
          <a-col :span="8">
            <a-card title="Şikayət təsnifatları" size="small">
              <a-table
                :columns="columns"
                :data-source="complaintClassifications"
                :loading="loadingComplaint"
                :row-key="record => record.id"
                :pagination="false"
                :custom-row="(record) => customRow(record, 'complaint')"
                :row-class-name="(record) => getRowClassName(record, 'complaint')"
                size="small"
              />
            </a-card>
          </a-col>

          <!-- 2. Qurum Təsnifatları Card-ı -->
          <a-col :span="8">
            <a-card title="Qurum təsnifatları" size="small">
              <a-table
                :columns="columns"
                :data-source="orgClassifications"
                :loading="loadingOrg"
                :row-key="record => record.id"
                :pagination="false"
                :custom-row="(record) => customRow(record, 'org')"
                :row-class-name="(record) => getRowClassName(record, 'org')"
                size="small"
              />
            </a-card>
          </a-col>

          <!-- 3. Redaktə Forması Card-ı -->
          <a-col :span="8">
            <a-card title="Seçilən təsnifat" size="small" v-show="selectedItem">
              <!-- Seçilmiş Təsnifatın Adı Bold İlə -->
              <div style="margin-bottom: 16px; font-size: 14px;">
                <b style="font-weight: bold !important">Seçilən təsnifat:</b>
                {{ selectedItem ? selectedItem.name || selectedItem.title : '' }}
              </div>

              <a-form :form="form" layout="vertical" @submit="handleSubmit">
                <!-- Təkli Seçimli TreeSelect Dropdown-u -->
                <a-form-item label="Yeni təsnifatlar">
                  <a-tree-select
                    v-decorator="[
                      'newClassificationId',
                      {
                        rules: [{ required: true, message: 'Zəhmət olmasa yeni təsnifatı seçin' }]
                      }
                    ]"
                    :loading="loadingNewCategories"
                    style="width: 100%"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    placeholder="Təsnifatı seçin"
                    allow-clear
                    show-search
                    tree-node-filter-prop="title"
                  >
                    <a-tree-select-node
                      v-for="cat in newClassificationsList"
                      :key="cat.id"
                      :value="cat.id"
                      :title="cat.name || cat.title"
                      :selectable="false"
                    >
                      <a-tree-select-node
                        v-for="subcat in cat.subCategories"
                        :key="subcat.id"
                        :value="subcat.id"
                        :title="subcat.name || subcat.title"
                      >
                        <a-tree-select-node
                          v-for="sscat in subcat.subCategories"
                          :key="sscat.id"
                          :value="sscat.id"
                          :title="sscat.name || sscat.title"
                        />
                      </a-tree-select-node>
                    </a-tree-select-node>
                  </a-tree-select>
                </a-form-item>

                <a-form-item>
                  <div style="display: flex; justify-content: flex-end; gap: 8px;">
                    <a-button @click="clearSelection">Ləğv et</a-button>
                    <a-button type="primary" htmlType="submit" :loading="submitting">
                      Göndər
                    </a-button>
                  </div>
                </a-form-item>
              </a-form>
            </a-card>

            <!-- Seçim edilmədikdə görünən blok -->
            <a-card size="small" v-show="!selectedItem" style="text-align: center; color: #8c8c8c; padding: 40px 0;">
              <p>Redaktə etmək üçün cədvəldən bir təsnifat seçin</p>
            </a-card>
          </a-col>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { apiCall, URL } from "@/utils/api";

export default {
  name: "CategoryModal",
  computed: {
    ...mapGetters({
      user: "user/user",
    }),
  },
  data() {
    return {
      isModalOpen: false,
      submitting: false,

      loadingComplaint: false,
      loadingOrg: false,
      loadingNewCategories: false,

      selectedItem: null,
      selectedSource: null,

      form: this.$form.createForm(this, { name: "category_edit_form" }),

      columns: [
        {
          title: "Adı",
          dataIndex: "name",
          key: "name",
          customRender: (text, record) => text || record.title,
        },
      ],

      complaintClassifications: [],
      orgClassifications: [],
      newClassificationsList: [],
    };
  },
  methods: {
    getProblemUuid() {
      const pathname = window.location.pathname;
      return pathname.split("/").pop();
    },

    openModal() {
      if (!this.user || !this.user.structure || this.user.structure.name !== 'AMIS') {
        return;
      }
      this.isModalOpen = true;
      this.fetchComplaintClassifications();
      this.fetchOrgClassifications();
      this.fetchNewClassifications();
    },

    handleClose() {
      this.clearSelection();
      this.isModalOpen = false;
      this.$emit("afterClose");
    },

    clearSelection() {
      this.selectedItem = null;
      this.selectedSource = null;
      this.form.resetFields();
    },

    // 1. Şikayət təsnifatları API
    async fetchComplaintClassifications() {
      this.loadingComplaint = true;
      const uuid = this.getProblemUuid();

      try {
        const res = await apiCall({
          url: URL[process.env.NODE_ENV].service_api + `problemcategories/byProblem/${uuid}`,
          method: "GET",
        });

        if (res && res.data && res.data.data) {
          this.complaintClassifications = res.data.data.map((item) => ({
            id: item.id,
            name: item.categoryDTO ? item.categoryDTO.name : item.name,
            newId: 0,
            isStructured: false,
            hasUpdate: item.checkedVersion
          }));
        }
      } catch (error) {
        this.$message.error("Şikayət təsnifatları yüklənərkən xəta baş verdi");
      } finally {
        this.loadingComplaint = false;
      }
    },

    // 2. Qurum təsnifatları API
    async fetchOrgClassifications() {
      this.loadingOrg = true;
      const uuid = this.getProblemUuid();

      try {
        const res = await apiCall({
          url: URL[process.env.NODE_ENV].service_api + `problemoffices/byProblem/${uuid}`,
          method: "GET",
        });

        if (res && res.data && res.data.data) {
          this.orgClassifications = res.data.data.map((item) => ({
            id: item.id,
            name: item.category ? item.category.name : (item.name || item.title),
            newId: 0,
            isStructured: true,
            hasUpdate: item.checkedVersion
          }));
        }
      } catch (error) {
        this.$message.error("Qurum təsnifatları yüklənərkən xəta baş verdi");
      } finally {
        this.loadingOrg = false;
      }
    },

    // 3. Single Selection TreeSelect daxilindəki API
    async fetchNewClassifications() {
      this.loadingNewCategories = true;
      try {
        const res = await apiCall({
          url: URL[process.env.NODE_ENV].auth_api + `categories?isNew=true&detailed=true&key=true`,
          method: "GET",
        });

        if (res && res.data && res.data.data) {
          this.newClassificationsList = res.data.data.entities || res.data.data;
        }
      } catch (error) {
        this.$message.error("Yeni təsnifatlar siyahısı yüklənmədi");
      } finally {
        this.loadingNewCategories = false;
      }
    },

    customRow(record, sourceType) {
      return {
        on: {
          click: () => {
            this.selectedItem = record;
            this.selectedSource = sourceType;

            this.$nextTick(() => {
              this.form.resetFields();
              if (record.newClassificationId) {
                this.form.setFieldsValue({
                  newClassificationId: record.newClassificationId,
                });
              }
            });
          },
        },
      };
    },

    getRowClassName(record, sourceType_) {
      const classNames = [];

      // 1. Seçilmiş sətir yoxlanışı
      if (
        this.selectedItem &&
        this.selectedItem.id === record.id &&
        this.selectedItem.isStructured === record.isStructured
      ) {
        classNames.push("selected-row");
      }

      // 2. Yenilənmiş sətir yoxlanışı
      if (record.hasUpdate) {
        classNames.push("row-updated");
      }

      return classNames.join(" ");
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.submitting = true;

          try {
            const payload = {
              problemCategoryNewDTO: !this.selectedItem.isStructured ? {
                id: this.selectedItem.id,
                categoryDTO: {
                  id: values.newClassificationId,
                }
              } : null,
              problemOfficeDTO: this.selectedItem.isStructured ? {
                id: this.selectedItem.id,
                category: {
                  id: values.newClassificationId,
                }
              } : null,
            };

            await apiCall({
              url: URL[process.env.NODE_ENV].service_api + `problemcategories/`,
              method: "PUT",
              data: payload,
            });

            this.$message.success("Təsnifat uğurla yeniləndi!");

            if (this.selectedItem && !this.selectedItem.isStructured) {
              this.fetchComplaintClassifications();
            } else {
              this.fetchOrgClassifications();
            }
            this.clearSelection();
          } catch (error) {
            // Backend-dən gələn dəqiq xətanı istifadəçiyə göstəririk
            const apiErrorMessage =
              error && error.response && error.response.data
                ? error.response.data.message || error.response.data.error
                : error.message || "Yenilənmə zamanı xəta baş verdi!";

            this.$message.error(apiErrorMessage);
            console.error("Gələn xəta obyekti:", error);
          } finally {
            this.submitting = false;
          }
        }
      });
    },
  },
};
</script>

<style scoped>

::v-deep .ant-table-tbody > tr {
  cursor: pointer !important;
}

::v-deep .ant-table-tbody > tr > td {
  cursor: pointer !important;
}

/* Seçilmiş sətrin fon rəngi */
::v-deep .selected-row,
::v-deep .selected-row > td {
  background-color: #e6f7ff !important;
}

/* Yenilənmiş sətrin fon rəngi */
::v-deep .row-updated,
::v-deep .row-updated > td {
  background-color: #00988838;
}

</style>

<style lang="scss" scoped src="./index.scss"></style>